module.exports = __webpack_public_path__ + "v.no2.69ecb8cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/v.no2.jpg
// module id = fFPE
// module chunks = 0